import { history } from "../../helpers/history";
import { USER } from "../../constants/LocalStorageOptions";

const handleLogout = () => {
  localStorage.removeItem(USER);
  history.push("/");
};

export default handleLogout;
